const initialState = {
  runningExperimentId: null,
};

const runningExperimentReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_RUNNING_EXPERIMENT_ID":
      return {
        ...state,
        runningExperimentId: action.payload,
      };
    default:
      return state;
  }
};

export default runningExperimentReducer;
